<template>
    <div class="know-how-page">
        <h1 v-if="lang=='fr'">
            Le savoir faire ...<br />
            Comme autrefois
        </h1>
        <h1 v-if="lang=='en'">
            Know-How :<br />
            Just like yesteryear !
        </h1>

        <flickity-box class="flickity" ref="flickity_1" :options="flickityOptions">
            <template>
            <div class="carousel-cell">
                <div class="img">
                    <img src="../assets/know_how_1.jpg" />
                </div>
                <div class="desc" v-if="lang == 'fr'">
                    <h2>Une matière : la peau</h2>
                    <p>
                        Le travail de la peau exige beaucoup de savoir-faire et d\'expérience. Pour vous proposer les meilleurs cuirs possibles, nous avons demandé à la Maison Fabre d’obtenir de son peaussier ses plus belles pièces. Elles ont été sélectionnées, baignées dans des bains de couleurs subtiles et différentes, travaillées et assouplies pour devenir le matériau noble que nous vous proposons.
                    </p>
                    <p>Pour un confort unique : une grande flexibilité, un toucher, une précision et une souplesse. En résumé : une seconde peau</p>
                </div>
                <div class="desc" v-if="lang == 'en'">
                    <h2>Skin as a fabric</h2>
                    <p>
                        Working natural skins requires much experience

                        and expertise. To obtain the highest quality of

                        leather, we asked Maison Fabre their skinners’

                        premium hides. They were selected, soaked in

                        baths of different and subtle shades, relaxed and

                        processed to become the noble material that we

                        proudly offer.
                    </p>
                    <p>
                        As a result, our gloves feature a comfort that

                        remains unmatched, with an amazing flexibility

                        and a very precise and refined touch. We call it a

                        second skin.
                    </p>
                </div>
            </div>

            <div class="carousel-cell">
                <div class="img">
                    <img src="../assets/know_how_2.png" />
                </div>
                <div class="desc" v-if="lang == 'fr'">
                    <h2>La coupe des peaux</h2>
                    <p>
                        Nos gants (main gauche - main droite) sont coupés
                        dans une même et unique peau afin d'avoir une
                        uniformité, une souplesse et une couleur
                        homogène. Notre coupeur utilise un gabarit en
                        fonction de la taille et de la coupe du gant. Il
                        travaille en pouce et trois parties se détachent
                        dans la coupe de nos gants :
                    </p>
                    <p>
                        1- le corps du gant : un carré qui formera le dessus
                        et dessous du gant<br />
                        2- le pouce : un carré qui aura la taille du pouce<br />
                        3- les fourchettes ou les entre-doigts : des bandelettes en forme de V.
                    </p>
                    <p>Pour un confort unique : une grande flexibilité, un toucher, une précision et une souplesse. En résumé : une seconde peau</p>
                </div>
                <div class="desc" v-if="lang == 'en'">
                    <h2>Skin cutting</h2>
                    <p>
                        Our gloves (left and right hands) are cut in the

                        same piece of skin in order to get the ultimate

                        consistency, flexibility and shade. Our cutter uses a

                        template based on the size and cut of the glove.

                        The cut of our gloves consist in three parts:
                    </p>
                    <p>
                        1 - the body of the glove: a square forming the top

                        and bottom of the glove<br />

                        2 - thumb: a square which will be thumb-sized<br />

                        3 – the “fourchettes” (finger pieces), which are V-

                        shaped strips.
                    </p>
                </div>
            </div>

            <div class="carousel-cell">
                <div class="img">
                    <img src="../assets/know_how_3.png" />
                </div>
                <div class="desc" v-if="lang == 'fr'">
                    <h2>La doublure</h2>
                    <p>
                        L'un des secrets du confort unique de nos gants :

                        sa doublure en soie et le contact de la peau crée

                        avec une réaction de chaleur à l'intérieur de

                        chaque gant.
                    </p>
                    <p>
                        Le cuir, même imperméabilisé, est traité pour une

                        respiration idéale et la soie permet d'enfiler le

                        gant très facilement.
                    </p>
                </div>
                <div class="desc" v-if="lang == 'en'">
                    <h2>The lining</h2>
                    <p>
                        One of the critical secrets to the great comfort of

                        our gloves is their silk lining.  Human skin and silk

                        are an amazing combination since their contact

                        creates heat inside each glove.
                    </p>
                    <p>
                        Leather, even waterproof, is treated to allow

                        breathing. Silk makes for an easy-to-slip-on

                        glove.
                    </p>
                </div>
            </div>

            <div class="carousel-cell">
                <div class="img">
                    <img src="../assets/know_how_4.jpg" />
                </div>
                <div class="desc" v-if="lang == 'fr'">
                    <h2>Le piqué anglais</h2>
                    <p>
                        Pour nos gants, nous utilisons du piqué anglais et
                        nos couturières montent d'abord le pouce puis les
                        entre-doigts, et terminent par les cotés des gants.
                    </p>
                </div>
                <div class="desc" v-if="lang == 'en'">
                    <h2>English pique stitch</h2>
                    <p>
                        For our gloves, we use English pique stitch. Our

                        sewers start by the thumb, which is very important

                        for the flexibility of the glove, then add the

                        fourchettes and the sides.
                    </p>
                </div>
            </div>

            <div class="carousel-cell">
                <div class="img">
                    <img src="../assets/know_how_5.png" />
                </div>
                <div class="desc" v-if="lang == 'fr'">
                    <h2>Doigts</h2>
                    <p>
                        "Comme une main nue ..." :
                        ni sensation d'épaisseur, ni risque de maladresse.
                        Car chaque doigt est indépendant, dans son écrin
                        de confort qui ne sacrifie rien à la précision.
                    </p>
                </div>
                <div class="desc" v-if="lang == 'en'">
                    <h2>Fingers</h2>
                    <p>
                        « Just like a bare hand… »:

                        avoid this thickness sensation and its related

                        clumsiness!

                        With Amelie’s gloves, each finger is independent in

                        its cozy case, which doesn’t detract from precision.
                    </p>
                </div>
            </div>
            </template>
        </flickity-box>


        <router-link to="/fabrication" v-if="lang=='fr'">L'atelier de fabrication</router-link>
        <router-link to="/fabrication-shop" v-if="lang=='en'">The fabrication shop</router-link>


    </div>

</template>

<script>
  import FlickityBox from './FlickityBox';

  export default {

    components: {
      FlickityBox,
    },
    props: ['lang'],
    data() {
      return {
        flickityOptions: {
          freeScroll: false,
          imagesLoaded: true,
          // prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          adaptiveHeight: false,
          cellAlign: 'left',

        },

      };
    },

    methods: {
    },
  };
</script>
<style lang="scss">
    .know-how-page {
        p {
            text-align: left;}

    }

</style>


// WEBPACK FOOTER //
// src/components/KnowHowPage.vue